<button mat-icon-button [matMenuTriggerFor]="profileMenu" aria-label="Notifications"
  class="d-flex justify-content-center align-items-center">
  @if (authService.loggerUser?.avatar) {
    <img [src]="authService.loggerUser?.avatar" [alt]="userName" class="rounded-circle">
  } @else {
    <app-text-avatar [name]="userName" [getCellStyles]="getAvatarStylesHeader"></app-text-avatar>
  }
</button>
<mat-menu #profileMenu="matMenu" class="topbar-dropdown cardWithShadow">
  <div>
    <div class="p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">{{ "user profile" | translate }}</h6>
      <a [routerLink]="profile.link" class="no-color-change">
        <div class="d-flex align-items-center p-b-16 b-b-1 m-t-12">
          @if (authService.loggerUser?.avatar) {
            <img [src]="authService.loggerUser?.avatar" [alt]="userName" class="avatar square-button rounded-circle">
          } @else {
            <app-text-avatar [name]="userName" [getCellStyles]="getAvatarStyles"></app-text-avatar>
          }
          <div class="m-l-16">
            <h6 class="f-s-14 f-w-600 m-0 mat-subtitle-1">
              {{userName || this.authService.loggerUser?.personalIdentifier}}
            </h6>
            @if (authService.loggerUser?.phoneNumber) {
              <span class="d-flex align-items-center">
                <i-tabler name="phone" class="icon-15 m-r-4"></i-tabler>
                {{authService.loggerUser?.phoneNumber}}
              </span>
            }
            @if (authService.loggerUser?.email) {
              <span class="d-flex align-items-center ">
                <i-tabler name="mail" class="icon-15 m-r-4"></i-tabler>
                <span class="email-text">{{ truncate(authService.loggerUser?.email ?? "", 15, "...")}}</span>
              </span>
            }
          </div>
        </div>
      </a>
      @for (itemDrop of profileDrop; track itemDrop.title) {
        <a [routerLink]="itemDrop.link"
          (click)="itemDrop.action ? itemDrop.action() : null" class="no-color-change cursor-pointer">
          <div class="d-flex align-items-center m-t-12">
            <div mat-mini-fab class="text-primary bg-light-primary shadow-none rounded p-4 p-b-0">
              @if (itemDrop.icon) {
                <mat-icon>{{ itemDrop.icon }}</mat-icon>
              }
              <img [src]="itemDrop.img" width="20" />
            </div>
            <div class="m-l-16">
              <h6 class="f-s-14 m-0 mat-subtitle-1">{{itemDrop.title | translate}}</h6>
            </div>
          </div>
        </a>
      }
    </div>
    <div class="p-y-12 p-x-32 green_theme">
      <a mat-stroked-button color="primary" class="w-100" (click)="logout()">{{ "logout" | translate }}</a>
    </div>
  </div>
</mat-menu>
